import React from 'react';
import { IconProps } from '.';

const SvgBoxFbk = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FAE100'
        d='M2 5.022A3.016 3.016 0 0 1 5.01 2h13.98A3.016 3.016 0 0 1 22 5.022v13.956A3.016 3.016 0 0 1 18.99 22H5.01A3.016 3.016 0 0 1 2 18.978V5.022Z'
      />
      <path fill='#E62F71' d='M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z' />
      <path
        fill='#FFE500'
        d='m16.652 13.409-4.834-3.55c-.666-.52-.654-.797-.642-1.088a.97.97 0 0 1 .112-.39c.064-.122.154-.23.264-.317a1.064 1.064 0 0 1 .794-.224c.142.016.278.06.401.128.123.069.23.16.315.27a.96.96 0 0 1 .19.771.384.384 0 0 0 .063.299.431.431 0 0 0 .577.107.397.397 0 0 0 .176-.254 1.724 1.724 0 0 0-.004-.739 1.762 1.762 0 0 0-.313-.675 1.852 1.852 0 0 0-.571-.498 1.962 1.962 0 0 0-1.501-.171c-.25.072-.48.193-.678.355a1.81 1.81 0 0 0-.47.586 1.736 1.736 0 0 0-.186.717c-.024.489.034 1.028.956 1.747l4.778 3.493c.1.102.055.216-.048.216H7.999c-.107 0-.15-.114-.049-.216l3.062-2.236a.387.387 0 0 0 .033-.529.433.433 0 0 0-.545-.094L7.373 13.41a.928.928 0 0 0-.338.487.89.89 0 0 0 .034.584c.08.164.21.301.373.394a.978.978 0 0 0 .54.124h8.031a.981.981 0 0 0 .54-.125.92.92 0 0 0 .373-.393.893.893 0 0 0 .047-.579.927.927 0 0 0-.32-.492Z'
      />
    </svg>
  );
};

export default SvgBoxFbk;
